export const panelStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  paddingTop: '16px',
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
};
